export function todayIso(): string {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

export function dateAt(date?: string, time?: string): Date | null {
  if (!date) return null;
  const parsed = new Date(`${date}T${time || '09:00'}:00`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatDate(date?: string, options: Intl.DateTimeFormatOptions = {}): string {
  if (!date) return 'No date';
  const parsed = new Date(`${date}T12:00:00`);
  if (Number.isNaN(parsed.getTime())) return date;
  return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric', ...options }).format(parsed);
}

export function formatTime(time?: string, format: '12' | '24' = '24'): string {
  if (!time) return '';
  const [hour, minute] = time.split(':').map(Number);
  const date = new Date();
  date.setHours(hour || 0, minute || 0, 0, 0);
  return new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hour12: format === '12' }).format(date);
}

export function daysFromToday(date?: string): number | null {
  if (!date) return null;
  const target = new Date(`${date}T12:00:00`);
  const today = new Date(`${todayIso()}T12:00:00`);
  if (Number.isNaN(target.getTime())) return null;
  return Math.round((target.getTime() - today.getTime()) / 86400000);
}

export function countdownLabel(date?: string): string {
  const days = daysFromToday(date);
  if (days === null) return '';
  if (days < 0) return `${Math.abs(days)} day${Math.abs(days) === 1 ? '' : 's'} overdue`;
  if (days === 0) return 'Today';
  if (days === 1) return 'Tomorrow';
  return `In ${days} days`;
}

export function nextRecurringDate(date: string, recurrence?: string): string {
  const parsed = new Date(`${date}T12:00:00`);
  if (Number.isNaN(parsed.getTime())) return date;
  if (recurrence === 'daily') parsed.setDate(parsed.getDate() + 1);
  else if (recurrence === 'weekly') parsed.setDate(parsed.getDate() + 7);
  else if (recurrence === 'fortnightly') parsed.setDate(parsed.getDate() + 14);
  else if (recurrence === 'monthly') parsed.setMonth(parsed.getMonth() + 1);
  else if (recurrence === 'quarterly') parsed.setMonth(parsed.getMonth() + 3);
  else if (recurrence === 'yearly') parsed.setFullYear(parsed.getFullYear() + 1);
  return `${parsed.getFullYear()}-${String(parsed.getMonth() + 1).padStart(2, '0')}-${String(parsed.getDate()).padStart(2, '0')}`;
}

export function startOfMonth(date = new Date()): Date {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function monthGrid(date: Date): Date[] {
  const first = startOfMonth(date);
  const start = new Date(first);
  const mondayIndex = (first.getDay() + 6) % 7;
  start.setDate(first.getDate() - mondayIndex);
  return Array.from({ length: 42 }, (_, index) => {
    const value = new Date(start);
    value.setDate(start.getDate() + index);
    return value;
  });
}

export function toIsoDate(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}
